import { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import Layout from './Layout'
import TrainingLayout from './TrainingLayout'
import DemoLayout from './DemoLayout'
import FallbackLayout from './FallbackLayout'
import AppStoreLayout from './AppStoreLayout'
import FeedbackLayout from './FeedbackLayout'

interface AppLayoutWrapperProps {
  children: ReactNode
}

const AppLayoutWrapper = ({ children }: AppLayoutWrapperProps) => {
  const location = useLocation()
  
  // Determine current application from pathname
  const getCurrentApplication = () => {
    const pathParts = location.pathname.split('/').filter(Boolean)
    if (pathParts.length > 0) {
      return pathParts[0]
    }
    return 'app' // default
  }

  const currentApp = getCurrentApplication()

  // Render appropriate layout based on current application
  switch (currentApp) {
    case 'app':
      // AppStore uses minimal layout (top bar only)
      return <AppStoreLayout>{children}</AppStoreLayout>
    
    case 'admin':
      return <Layout>{children}</Layout>
    
    case 'iam':
      // IAM uses the main Admin Layout
      return <Layout>{children}</Layout>
    
    case 'training':
      return <TrainingLayout>{children}</TrainingLayout>
    
    case 'demo':
      return <DemoLayout>{children}</DemoLayout>
    
    case 'feedback':
      return <FeedbackLayout>{children}</FeedbackLayout>
    
    case 'fallbackapp':
      return <FallbackLayout>{children}</FallbackLayout>
    
    default:
      return <Layout>{children}</Layout>
  }
}

export default AppLayoutWrapper